import { AuthSession } from '../../../types';

/**
 * Platform-agnostic session storage adapter interface
 * Allows different platforms (web, mobile) to implement their own storage mechanisms
 */
export interface SessionStorageAdapter {
  /**
   * Store session data
   */
  storeSession(session: AuthSession): Promise<void>;

  /**
   * Retrieve stored session data
   */
  getSession(): Promise<AuthSession | null>;

  /**
   * Clear stored session data
   */
  clearSession(): Promise<void>;

  /**
   * Check if session storage is available
   */
  isAvailable(): boolean;
}

/**
 * No-op adapter for platforms without session storage
 */
export class NoOpSessionAdapter implements SessionStorageAdapter {
  async storeSession(_session: AuthSession): Promise<void> {
    // No-op
  }

  async getSession(): Promise<AuthSession | null> {
    return null;
  }

  async clearSession(): Promise<void> {
    // No-op
  }

  isAvailable(): boolean {
    return false;
  }
}
